export const DECORATORS:{[key:string]:string} = {
    disabled:'disabled',
    error: 'error',
    trim:'trim',
    ltrim:'ltrim',
    rtrim:'rtrim',
    blacklist:'blacklist',
    stripLow:'stripLow',
    toBoolean:'toBoolean',
    toDate:'toDate',
    toDouble:'toDouble',
    toFloat:'toFloat',
    toInt:'toInt',
    string:'toString',
    whitelist: 'whitelist',
    escape: 'escape',
    prefix: 'prefix',
    suffix: 'suffix',
    sanitize: 'sanitize',
    elementClass: 'elementClass',
    updateOn:'updateOn'
}